import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const SELECTED_TOPIC_BLOCK_WIDTH = 360;

export const StyledIntentTopicBlock = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledIntentHeader = styled.div`
    ${mixins.setFontVariant("h4", colorsPalettes.carbon["400"])}
`;

export const StyledIntentButtonWrapper = styled.div`
    display: flex;
    margin-bottom: 16px;
`;

export const StyledIntentSubHeaderBlock = styled(FlexRow)``;

export const StyledIntentSubHeader = styled.div`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["300"])}
`;

export const StyledIntentTopicViewLink = styled.a`
    ${mixins.setFontVariant("button", colorsPalettes.blue["400"])};
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 8px;

    &:hover {
        ${mixins.setFontVariant("button", colorsPalettes.blue["500"])};

        & svg path {
            fill: ${colorsPalettes.blue["500"]};
            fill-opacity: 1;
            stroke: none;
        }
    }
`;

export const StyledIntentTopicViewIcon = styled(SWReactIcons)`
    margin-left: 4px;

    & svg path {
        fill: ${colorsPalettes.blue["400"]};
        fill-opacity: 1;
        stroke: none;
    }
`;

export const StyledIntentMainBlock = styled(FlexRow)`
    margin-top: 16px;
    width: 100%;
    height: 100%;
    flex-grow: 1;
`;

export const StyledIntentTopicContainer = styled(FlexColumn)`
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    border-radius: 8px;
    overflow: hidden;
    width: calc(100% - ${SELECTED_TOPIC_BLOCK_WIDTH}px);
    background: ${colorsPalettes.carbon["0"]};
    height: 100%;
    margin-right: 8px;
    position: relative;
`;

export const StyledIntentTopicSelectedContainer = styled.div`
    display: flex;
    border-radius: 8px;
    background: ${colorsPalettes.carbon["0"]};
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    width: 352px;
`;
